export default "<app-tutor-toolbar></app-tutor-toolbar>\n<main>\n    <app-class-tile myClass=\"10 (CIT)\"></app-class-tile>\n</main>\n"